// client/src/components/clientPortal/PortalPrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useClientPortalAuth } from '../../hooks/useClientPortalAuth';

const PortalPrivateRoute = ({ children }) => {
    const { token } = useClientPortalAuth();
    return token ? children : <Navigate to="/client-portal/login" />;
};

export default PortalPrivateRoute;
